/**
 * Created by Kristy on 22/6/2017.
 */

(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('medReport', {
                parent: 'adminIndex',
                url: '/medReport',
                data: {
                    authorities: ['ROLE_CHECKER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/displays/adminIndex/medReport/medReport.html',
                        controller: 'MedReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    employee: ['$http', function($http) {
                        return $http.get('/api/employees/me')
                    }],
                    favouriteFilters: ['$http', function($http) {
                        return $http.get('/api/favourite-filters/search', {params: { filter: { filters: [{
                            "field": "viewName", "operator": "eq",
                            "value": "medReport"
                        }] } }} );
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

    }

})();
